import { faImage } from "@fortawesome/pro-solid-svg-icons"
import { Grid, IconButton, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useAppLocalization } from "../../../localization/components/AppLocalizationProvider"
import { StandardChip } from "../../../../shared/components/badges/StandardChip"
import { ProductTableRow } from "./productsTypes"
import { StockChip } from "./components/stockManagement/StockChip"

type ProductGroupItemBoxProps = Readonly<{
    productGroup: ProductTableRow
}>

export function ProductGroupItemBox({ productGroup }: ProductGroupItemBoxProps) {
    return (
        <Typography variant="body1" fontWeight="bold">
            {productGroup.name}
        </Typography>
    )
}

type ProductNameProps = Readonly<{
    product: ProductTableRow
    onProductPhotoClick: (imageUrl: string) => void
    onStockChipClick?: (event: React.MouseEvent<HTMLElement>, productId: number) => void
    activeStockProductId?: number | null
}>

export function ProductName({
    product,
    onProductPhotoClick,
    onStockChipClick,
    activeStockProductId,
}: ProductNameProps) {
    const { l10n } = useAppLocalization()
    const productPhotoUrl = product.productPhoto?.url

    return (
        <Grid container>
            <Grid container item gap="1rem" alignItems="center" wrap="nowrap">
                <Grid item>{product.name}</Grid>
                {productPhotoUrl && (
                    <Grid item>
                        <IconButton onClick={() => onProductPhotoClick(productPhotoUrl)} sx={{ padding: 0 }}>
                            <FontAwesomeIcon icon={faImage} fontSize="16px" color="#94A3B8" />
                        </IconButton>
                    </Grid>
                )}
                {product.marketingDetails?.isOffer && (
                    <Grid item>
                        <StandardChip
                            size="small"
                            label={l10n.getString("product-offer-chip")}
                            variant="yellow"
                            placement="table"
                        />
                    </Grid>
                )}
                {product.type === "product" && product.stock && (
                    <Grid item>
                        <StockChip
                            stock={product.stock}
                            isOpen={activeStockProductId === product.id}
                            onClick={(e) => onStockChipClick?.(e, product.id)}
                        />
                    </Grid>
                )}
            </Grid>
            {/* {product.type === "product" && product.stock && (product.stock.itemsLeftToday ?? 0) > 0 && (
                <Grid container item>
                    <Typography variant="caption" color="text.secondary">
                        {l10n.getString("product-stock-daily-sales", { count: product.stock.itemsLeftToday! })}
                    </Typography>
                </Grid>
            )} */}
        </Grid>
    )
}
